import React, { useState } from 'react'
import AccordionTitle from './AccordionTitle'
import AccordionContent from './AccordionContent'
import Accordion from './Base'
import Link from '../Link'

const ToggleAccordion = ({ children, title }) => {
  const [statusAccordion, setstatusAccordion] = useState(true)
  const toggleAccordion = () => setstatusAccordion(!statusAccordion)

  return (
    <Accordion>
      <AccordionTitle onClick={toggleAccordion}>
        <Link icon="info">{title}</Link>
      </AccordionTitle>
      <AccordionContent statusAccordion={statusAccordion}>{children}</AccordionContent>
    </Accordion>
  )
}

export default ToggleAccordion
